<h1 mat-dialog-title>{{ data.title }}</h1>
<mat-dialog-content class="mat-typography">
  <p>{{ data.message }}</p>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-raised-button [mat-dialog-close]="false">{{ data.cancelText }}</button>
  <button
    mat-raised-button
    [color]="data.okayButtonColored === false ? null : 'warn'"
    [mat-dialog-close]="true"
    cdkFocusInitial
  >
    {{ data.okayText }}
  </button>
</mat-dialog-actions>